import React from 'react'

export default function HealthCenter() {
    return (
        <div>HealthCenter</div>
    )
}
